import {AbstractEvent} from "@/modules/base/events";
import {Suspension} from "@/modules/competitions/entity";

export class AfterPlayerSuspendedEvent extends AbstractEvent {
  constructor(
    public suspension: Suspension,
  ) {
    super();
  }
}